import { Controller } from "stimulus"
import L from "leaflet"

export default class extends Controller {
    static targets = ["map", "status"]

    connect() {

      var TypeIcon = L.Icon.extend({
          options: {
            shadowUrl: '/flags/ena.png',
            shadowAnchor: [1, 20],
            iconSize:     [26, 40], // size of the icon
            iconAnchor:   [13, 38], // point of the icon which will correspond to marker's location
            popupAnchor:  [0, -41] // point from which the popup should open relative to the iconAnchor
          }
      });

      var schoolIcon = new TypeIcon({iconUrl: '/flags/skolas.png'})

      var map = L.map(this.mapTarget).setView([56.8801729, 24.6057484], 7);
      this.map = map;
      L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        id: 'mapbox/streets-v11',
        tileSize: 512,
        zoomOffset: -1,
        accessToken: 'pk.eyJ1IjoicGF0aXppdnMiLCJhIjoiY2ppaGlwaHU0MThiYjN2b2NvdHp5c3JqeCJ9.U7-N2HT0Cz7ekwr6kF_-dQ'
      }).addTo(map);


      this.abortController = new AbortController();
      fetch("/sprouts/active.json", { signal: this.abortController.signal })
        .then(response => {
          if (!response.ok) throw new Error("Map request failed");
          return response.json();
        })
        .then(data => {
          data.forEach(function (item, index) {

            var icon = schoolIcon
            var marker = L.marker([item.latitude, item.longitude], {icon: icon}).addTo(map);
            const popup = document.createElement("div");
            [item.school_name, item.event_date, item.place, item.description].forEach((value, position) => {
              const line = document.createElement(position === 0 ? "strong" : "div");
              line.textContent = value || "";
              popup.appendChild(line);
            });
            marker.bindPopup(popup);
          });
          this.statusTarget.textContent = data.length ? `Kartē ${data.length} pasākumi.` : "Kartē vēl nav pasākumu.";
        })
        .catch(error => {
          if (error.name !== "AbortError") this.statusTarget.textContent = "Karti neizdevās papildināt ar pasākumiem. Lūdzu, pārlādējiet lapu.";
        })
        map.addControl(new L.Control.Fullscreen({
          pseudoFullscreen: true,
          title: {
            'false': 'Skats pilnekrāna režīmā',
            'true': 'Iziet no pilnekrāna režīma'
          }
        }));
  }

  disconnect() {
    if (this.abortController) this.abortController.abort();
    if (this.map) this.map.remove();
  }
}

